import { render, staticRenderFns } from "./SendEmailOTP.vue?vue&type=template&id=25aff1ce&scoped=true"
import script from "./SendEmailOTP.vue?vue&type=script&lang=js"
export * from "./SendEmailOTP.vue?vue&type=script&lang=js"
import style0 from "./SendEmailOTP.vue?vue&type=style&index=0&id=25aff1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aff1ce",
  null
  
)

export default component.exports